"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransport = void 0;
const fetch_1 = require("rxjs/fetch");
const operators_1 = require("rxjs/operators");
function fetchTransport(input) {
    const headers = new Headers(Object.assign({ Accept: 'application/json;charset=utf-8' }, input.headers));
    const request = new Request(input.url, {
        method: input.method,
        headers: headers,
        credentials: input.credentials,
        mode: input.mode,
        body: input.body
    });
    return (0, fetch_1.fromFetch)(request).pipe((0, operators_1.mergeMap)((r) => r
        .json()
        .catch((e) => {
        console.error(e);
        return null;
    })
        .then((data) => {
        const headers = {};
        r.headers.forEach((v, k) => {
            headers[k] = v;
        });
        return {
            status: r.status,
            headers: headers,
            body: data
        };
    })));
}
exports.fetchTransport = fetchTransport;
//# sourceMappingURL=fetchTransport.js.map